import { adminAPIService } from './index'

const route = 'dashboards'

export default {
}
